var css = css || {};
css.actualizar = function(){
	var actualizando = false;
	var hayCambios = false;

	/**
	 * Repinta la pantalla
	 */
	function repintar(){
		$(window).scrollTop($(window).scrollTop());
	}

	/**
	 * Comprueba si los css actuales de la página necesitan refrescarse
	 */
	function comprobarActualizarCss(){
		if(actualizando)
			return;
		actualizando = true;

		var lcss = [];
		var links = $("link[type=\"text/css\"]");
		links.each(
			function(){
				lcss.push($(this).attr("href"));
			}
		);

		if(hayCambios){
			repintar();
			hayCambios = false;
		}
		nbf.ejecutar(
			"nbf\\configResCss::ajaxComprobarActualizarCss",
			[lcss],
			function(respuesta){
				actualizando = false;
				if(respuesta.status=="ok"){
					for(var i in respuesta.urls){
						if(respuesta.urls[i]){
							links.eq(i).attr("href",respuesta.urls[i]);
							hayCambios = true;
						}
					}
				}
			}
		);
	}

	var h = nbf.url.leerParamHash("actualizarcss");
	if(h){ //si se pasa #actualizarcss=on/off en la url, se activa o desactiva
		var d = new Date();
		var act = (h=="on");
		d.setTime(d.getTime()+((act?1:-1)*3600*24));
		document.cookie = "nbfCssActualizar="+(act?"1":"")+"; expires="+d.toGMTString()+"; path=/";
		alert("CSS auto refresh "+(act?"activo":"inactivo"));
		window.location = "#";
	}
	if(document.cookie.indexOf("nbfCssActualizar=1")>-1)
		setInterval(comprobarActualizarCss,1000);
}();
